import React, { useState } from "react";
import {
  CardTitle,
  CardBody,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  Container,
} from "reactstrap";
import PasswordSshkeyInputGroup from "./CollectionDeviceInputs/PasswordSshkeyInputGroup";
import TokenInVaultInputs from "./CollectionDeviceInputs/TokenInVaultInputs";
import HitachiInputs from "./CollectionDeviceInputs/HitachiInputs";
import EcsInputs from "./CollectionDeviceInputs/EcsInputs";
// import PureFlashBladeInputs from "./CollectionDeviceInputs/PureFlashBladeInputs";
import CohesityInputs from "./CollectionDeviceInputs/CohesityInputs";
import OracleDatabaseInputs from "./CollectionDeviceInputs/OracleDatabaseInputs";
import Db2DatabaseInputs from "./CollectionDeviceInputs/Db2DatabaseInputs";
// import GoogleCloudInputs from "./CollectionDeviceInputs/GoogleCloudInputs";
import PrometheusInputs from "./CollectionDeviceInputs/PrometheusInputs";
import BrocadeInputs from "./CollectionDeviceInputs/BrocadeInputs";
import RubrikRscInputs from "./CollectionDeviceInputs/RubrikRscInputs";
import ThreeParInputs from "./CollectionDeviceInputs/ThreeParInputs";
import { VsiBubble } from "../../styled/App.styled";
import themeStyles from "../../utils/themeStyles";
import { useVsiAppContext } from "../../stores/VsiApp";
import VsiLabeledSelect from "../../components/VsiLabeledSelect";
import Nouns from "./CollectionDeviceInputs/Nouns";

import { validateIp } from "../../utils/Helpers";

export default function DeviceCard({ device, setDeviceCallback, index }) {
  const { theme } = useVsiAppContext();
  const [refresh, setRefresh] = useState(false);

  const handleInputChange = (event) => {
    let { name, value } = event.target;
    if (name === "timeout" && value > 24) {
      value = 24;
    }
    if (name === "timeout" && value < 1) {
      value = "";
    }
    if (name === "report_rtm_data" && typeof value !== "boolean") {
      value = value !== "true";
    }

    setDeviceCallback({
      ...device,
      [name]: value,
    }, index);
    setRefresh(!refresh);
  };

  const handleMultiSelectChange = (selectedItems) => {
    let collectionDays = [...selectedItems];
    let collectionDay = selectedItems.map(({ value }) => value).join(",")
    setDeviceCallback({
      ...device,
      collectionDays,
      collectionDay,
      collection_day: collectionDay,
    }, index);
    // validateForm();
    setRefresh(!refresh);
  };

  const fileAnalysis = () => {
    return (
      <Row>
        <Col sm={6} lg={6}>
          <Label htmlFor="cli_path">Share Path</Label>
          <Input
            type="text"
            value={device?.cli_path}
            name="cli_path"
            onChange={handleInputChange}
          />
        </Col>
        <Col sm={6} lg={6}>
          <Label htmlFor="site_code">Collection Machine (Optional)</Label>
          <Input
            type="text"
            name="site_code"
            value={device?.site_code}
            onChange={handleInputChange}
          />
        </Col>
        <Col lg={6} sm={6}>
          <Label htmlFor="device_alias">Device Alias (Optional)</Label>
          <Input
            type="text"
            name="device_alias"
            value={device?.device_alias}
            onChange={handleInputChange}
          />
        </Col>
        <Col sm={6} lg={6}>
          <Label htmlFor="collectionDays">
            Collection Day(s)
            {device?.collectionDays?.length === 0 && (
              <span className="badge bg-danger"> Required </span>
            )}
          </Label>
          <VsiLabeledSelect
            defaultValue={device?.collectionDays}
            minWidth={"100%"}
            options={[
              { value: "mon", label: "Monday" },
              { value: "tue", label: "Tuesday" },
              { value: "wed", label: "Wednesday" },
              { value: "thurs", label: "Thursday" },
              { value: "fri", label: "Friday" },
              { value: "sat", label: "Saturday" },
              { value: "sun", label: "Sunday" },
            ]}
            name="collectionDays"
            isMulti
            onChange={handleMultiSelectChange}
          />
        </Col>

        <Col sm={6} lg={6}>
          <Label htmlFor="collection_time">Collection Time</Label>
          <Input
            id={"collection_time"}
            type="time"
            size="large"
            required={false}
            name="collection_time"
            value={device?.collection_time}
            className={"form-control"}
            onChange={handleInputChange}
            step={300}
          />
        </Col>

        <Col sm={6} lg={6}>
          <Label htmlFor="timeout">Collection Timeout (hrs)</Label>
          <Input
            value={device?.timeout}
            name="timeout"
            type="number"
            id={`device-timeout`}
            onChange={handleInputChange}
          />
        </Col>
      </Row>
    );
  };

  const growthRateCalcs = () => {
    return (
      <Row>
        <Col lg={4} sm={6}>
                  <Label htmlFor="collectionDays">
                    Calculation Day(s)
                    {device?.collectionDays.length === 0 && (
                      <span className="badge bg-danger"> Required </span>
                    )}
                  </Label>
                  <VsiLabeledSelect
                    defaultValue={device?.collectionDays}
                    minWidth={"100%"}
                    options={[
                      { value: "mon", label: "Monday" },
                      { value: "tue", label: "Tuesday" },
                      { value: "wed", label: "Wednesday" },
                      { value: "thurs", label: "Thursday" },
                      { value: "fri", label: "Friday" },
                      { value: "sat", label: "Saturday" },
                      { value: "sun", label: "Sunday" },
                    ]}
                    name="collectionDays"
                    isMulti
                    onChange={handleMultiSelectChange}
                  />
                </Col>
                <Col lg={3} sm={6}>
                  <Label htmlFor="collection_time">Calculation Time</Label>
                  <Input
                    id={"collection_time"}
                    type="time"
                    size="large"
                    required={false}
                    name="collection_time"
                    value={device?.collection_time}
                    className={"form-control"}
                    onChange={handleInputChange}
                    step={300}
                  />
                </Col>
                <Col lg={2} sm={6}>
                  <Label htmlFor="timeout">Calculation Timeout (hrs)</Label>
                  <Input
                    value={device?.timeout}
                    name="timeout"
                    type="number"
                    id={`device-timeout-${index}`}
                    onChange={handleInputChange}
                  />
                </Col>
      </Row>
    )
  }

    const googleCloud = () => {
        return (
            <Row>
                <Col lg={6} sm={6}>
                    <FormGroup>
                        <Label htmlFor="cli_path">Service Account Key Path</Label>
                        <span className="badge bg-danger">Required </span>
                        <Input
                            required={true}
                            type="text"
                            name="cli_path"
                            value={device?.cli_path}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg={6} sm={6}>
                    <Label htmlFor="device_alias">Device Alias (Optional)</Label>
                    <Input
                        type="text"
                        name="device_alias"
                        value={device?.device_alias}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col lg={3} sm={6}>
                    <Label htmlFor="site_code">Collection Machine (Optional)</Label>
                    <Input
                        type="text"
                        name="site_code"
                        defaultValue={device?.site_code}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col lg={4} sm={6}>
                    <Label htmlFor="collectionDays">
                        Collection Day(s)
                        {device?.collectionDays.length === 0 && (
                            <span className="badge bg-danger"> Required </span>
                        )}
                    </Label>
                    <VsiLabeledSelect
                        defaultValue={device?.collectionDays}
                        minWidth={"100%"}
                        options={[
                            {value: "mon", label: "Monday"},
                            {value: "tue", label: "Tuesday"},
                            {value: "wed", label: "Wednesday"},
                            {value: "thurs", label: "Thursday"},
                            {value: "fri", label: "Friday"},
                            {value: "sat", label: "Saturday"},
                            {value: "sun", label: "Sunday"},
                        ]}
                        name="collectionDays"
                        isMulti
                        onChange={handleMultiSelectChange}
                    />
                </Col>
                <Col lg={3} sm={6}>
                    <Label htmlFor="collection_time">Collection Time</Label>
                    <Input
                        id={"collection_time"}
                        type="time"
                        size="large"
                        required={false}
                        name="collection_time"
                        value={device?.collection_time}
                        className={"form-control"}
                        onChange={handleInputChange}
                        step={300}
                    />
                </Col>
                <Col lg={2} sm={6}>
                    <Label htmlFor="timeout">Collection Timeout (hrs)</Label>
                    <Input
                        value={device?.timeout}
                        name="timeout"
                        type="number"
                        id={`device-timeout-${index}`}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col lg={6} sm={6}>
                    <FormGroup>
                        <Label htmlFor="domain">Billing Export Name (Optional)</Label>
                        <Input
                            required={true}
                            type="text"
                            name="domain"
                            value={device?.domain}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
        )
    }

  return (
    <VsiBubble
      className="mb-4"
      noAutobot
      style={{
        backgroundColor: device.is_valid ? "" : "lightred",
        color: themeStyles[theme].textColor,
        fontSize: "80%",
      }}
    >
      <CardBody>
        <Container fluid>
          <CardTitle tag="h4">
            {device?.device_type_code} (
            {device?.hitachi_ops ? device?.hitachi_ops : index + 1})
          </CardTitle>
          {(() => {
            switch (device?.device_type_code) {
                case 'FILE_ANALYSIS':
                case 'TEST_FILE_ANALYSIS':
                    return fileAnalysis();
                case 'GROWTH_RATE_CALC':
                    return growthRateCalcs();
                case 'GOOGLE_CLOUD_DEVICE':
                    return googleCloud();
                default:
                    return <div>
              <Row>
                <Col
                  sm={
                    device?.isCompellent ||
                    device?.device_type_code?.includes?.("ORACLE_EXADATA")
                      ? 4
                      : 6
                  }
                >
                  <Label htmlFor="ip_address">
                    IP Address/DNS Entry Name
                    {!validateIp(device?.ip_address) && (
                      <span className="badge bg-danger">
                        {" "}
                        Invalid IP Address/DNS Entry Name
                      </span>
                    )}
                  </Label>

                  <Input
                    required
                    type="text"
                    name="ip_address"
                    defaultValue={device?.ip_address}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col
                  sm={
                    device?.isCompellent ||
                    device?.device_type_code?.includes?.("ORACLE_EXADATA")
                      ? 4
                      : 6
                  }
                >
                  <Label htmlFor="device_alias">Device Alias (Optional)</Label>
                  <Input
                    type="text"
                    name="device_alias"
                    defaultValue={device?.device_alias}
                    onChange={handleInputChange}
                  />
                </Col>
                {device?.isCompellent ||
                device?.device_type_code?.includes?.("XTREMIO") ? (
                  <Col sm={4}>
                    <Label htmlFor="array_name">Array Name</Label>
                    <Input
                      type="text"
                      name="array_name"
                      defaultValue={device?.array_name}
                      onChange={handleInputChange}
                    />
                  </Col>
                ) : null}
                {device?.isCompellent ||
                device?.device_type_code?.includes?.("ORACLE_EXADATA") ? (
                  <Col sm={4}>
                    <Label htmlFor="secondary_ip">Cells</Label>
                    <Input
                      type="text"
                      name="secondary_ip"
                      defaultValue={device?.secondary_ip}
                      onChange={handleInputChange}
                    />
                  </Col>
                ) : null}
                {device?.device_type_code?.includes("INFINIDAT_DEVICE") ? (
                  <Col sm={6}>
                    <Label htmlFor="secondary_ip">InfiniMetrics IP</Label>
                    <Input
                      type="text"
                      name="secondary_ip"
                      defaultValue={device?.secondary_ip}
                      onChange={handleInputChange}
                    />
                  </Col>
                ) : null}
                {device?.usesCliPath ? (
                  <Col xs={12} sm={6}>
                    <Label htmlFor="cli_path">CLI Path</Label>
                    <Input
                      required
                      type="text"
                      name="cli_path"
                      defaultValue={device?.cli_path}
                      onChange={handleInputChange}
                    />
                  </Col>
                ) : null}
                <BrocadeInputs
                    device={device?.device_type_code}
                    array_name={device?.array_name}
                    handleInputChange={handleInputChange}
                    lgColSize={4}
                />
                <HitachiInputs
                    device={device}
                    cli_path={device?.cli_path}
                    port={device?.port}
                    api_token={device?.api_token}
                    handleInputChange={handleInputChange}
                    lgColSize={4}
                />
                <EcsInputs
                  device={device?.device_type_code}
                  path={device?.path}
                  handleInputChange={handleInputChange}
                  lgColSize={4}
                />
                <OracleDatabaseInputs
                  device={device?.device_type_code}
                  port={device?.port}
                  array_name={device?.array_name}
                  handleInputChange={handleInputChange}
                  lgColSize={4}
                />
                <Db2DatabaseInputs
                  device={device?.device_type_code}
                  port={device?.port}
                  array_name={device?.array_name}
                  handleInputChange={handleInputChange}
                  lgColSize={4}
                />
                <PrometheusInputs
                      device={device?.device_type_code}
                      port={device?.port}
                      handleInputChange={handleInputChange}
                      lgColSize={4}
                />
                <RubrikRscInputs
                    device={device?.device_type_code}
                    array_name={device?.array_name}
                    handleInputChange={handleInputChange}
                    lgColSize={4}
                />
                <ThreeParInputs
                  device={device?.device_type_code}
                  port={device?.port}
                  handleInputChange={handleInputChange}
                  lgColSize={4}
                />
                <CohesityInputs
                  device={device?.device_type_code}
                  domain={device?.domain}
                  apiToken={device?.api_token}
                  handleInputChange={handleInputChange}
                  lgColSize={4}
                />
              </Row>
              <Row>
                <Col lg={4} sm={6}>
                  <Label htmlFor="username">Username</Label>
                  <Input
                    required
                    type="text"
                    name="username"
                    defaultValue={device?.username}
                    onChange={handleInputChange}
                  />
                </Col>
                {Nouns.TokenInVaultDevices.includes(device?.device_type_code) ? (
                  <TokenInVaultInputs
                    password={device?.password}
                    handleInputChange={handleInputChange}
                    lgColSize={4}
                  />
                ) : (
                  <PasswordSshkeyInputGroup
                    lgColSize={4}
                    smColSize={6}
                    xsColSize={12}
                    handleInputChange={handleInputChange}
                    password={device?.password}
                    confirmPassword={device?.confirmPassword}
                    sshKey={device?.ssh_key}
                    resetInputs={() => {
                      device["password"] = "";
                      device["confirmPassword"] = "";
                      device["ssh_key"] = "";
                    }}
                  />
                )}
                {Nouns.portDevices.some((portDevice) =>
                  device?.device_type_code.includes(portDevice)
                ) ? (
                  <Col lg={4} sm={6}>
                    <FormGroup>
                      <Label htmlFor="port">Port</Label>
                      <Input
                        required
                        type="text"
                        name="port"
                        defaultValue={device?.port}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                ) : null}
              </Row>
              <Row>
                <Col lg={3} sm={6}>
                  <Label htmlFor="site_code">Collection Machine (Optional)</Label>
                  <Input
                    type="text"
                    name="site_code"
                    defaultValue={device?.site_code}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col lg={4} sm={6}>
                  <Label htmlFor="collectionDays">
                    Collection Day(s)
                    {device?.collectionDays.length === 0 && (
                      <span className="badge bg-danger"> Required </span>
                    )}
                  </Label>
                  <VsiLabeledSelect
                    defaultValue={device?.collectionDays}
                    minWidth={"100%"}
                    options={[
                      { value: "mon", label: "Monday" },
                      { value: "tue", label: "Tuesday" },
                      { value: "wed", label: "Wednesday" },
                      { value: "thurs", label: "Thursday" },
                      { value: "fri", label: "Friday" },
                      { value: "sat", label: "Saturday" },
                      { value: "sun", label: "Sunday" },
                    ]}
                    name="collectionDays"
                    isMulti
                    onChange={handleMultiSelectChange}
                  />
                </Col>
                <Col lg={3} sm={6}>
                  <Label htmlFor="collection_time">Collection Time</Label>
                  <Input
                    id={"collection_time"}
                    type="time"
                    size="large"
                    required={false}
                    name="collection_time"
                    defaultValue={device?.collection_time}
                    className={"form-control"}
                    onChange={handleInputChange}
                    step={300}
                  />
                </Col>
                <Col lg={2} sm={6}>
                  <Label htmlFor="timeout">Collection Timeout (hrs)</Label>
                  <Input
                    defaultValue={device?.timeout}
                    name="timeout"
                    type="number"
                    id={`device-timeout-${index}`}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label htmlFor="report_rtm_data">Enable interval reporting?</Label>
                  <Input
                    className={"ms-2"}
                    defaultChecked={device?.report_rtm_data ?? false}
                    value={device?.report_rtm_data ?? false}
                    name="report_rtm_data"
                    type="checkbox"
                    id={`device-report_rtm_data-${index}`}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
              {/* we should be building the form with a factory or a builder, not create an exception every time some device has different fields.  fix this in V6. */}
              {device?.device_type_code.includes("VMAX") || device?.device_type_code.includes("POWERMAX_DEVICE") ? (
                <Row>
                  <Col lg={4} sm={6}>
                    <Label htmlFor="serial_number">Serial Number</Label>
                    {!(device?.serial_number) && (
                      <span className="badge bg-danger">
                        {" "}
                        Required
                      </span>
                    )}
                    <Input
                      required
                      type="text"
                      name="serial_number"
                      defaultValue={device?.serial_number}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Row>
              ) : null}
            </div>
            }
          })()}
        </Container>
      </CardBody>
    </VsiBubble>
  );
}
